import { Image, Space } from "antd";
import SummaryWrapper from "../SummaryWrapper";
import {
  cardioGoalsOptions,
  neuroGoalsOptions,
  orthoGoalsOptions,
  sportsGoalsOptions,
} from "../../Options/physioOptions";
import {
  getLabelTagsArray,
  getLabelTagsWithDynamicInputs,
  hasDynamicOthersContent,
} from "../constructTextFromValues";
import therapeuticgoalsIcon from "../../../../assets/doctorIcons/therapeuticGoals.svg";

const PhysioTherapeuticGoalsSummary = ({ formData }) => {
  const constructTherapeuticGoalsSummaryItems = () => {
    const therapeuticGoalsSummaryItems = [];
    const goals = formData?.therapeutic_goals || {};
    const pushGoalsItems = (key, label, children) => {
      therapeuticGoalsSummaryItems.push({ key, label, children });
    };
    if (goals?.cardio) {
      pushGoalsItems(
        "1",
        "Cardio",
        <>
          {getLabelTagsArray(cardioGoalsOptions, goals?.cardio_details)}
          {hasDynamicOthersContent(goals?.cardio_others)
            ? getLabelTagsWithDynamicInputs(goals?.cardio_others)
            : null}
        </>
      );
    }
    if (goals?.ortho) {
      pushGoalsItems(
        "2",
        "Ortho",
        <>
          {getLabelTagsArray(orthoGoalsOptions, goals?.ortho_details)}
          {hasDynamicOthersContent(goals?.ortho_others)
            ? getLabelTagsWithDynamicInputs(goals?.ortho_others)
            : null}
        </>
      );
    }
    if (goals?.sports) {
      pushGoalsItems(
        "3",
        "Sports",
        <>
          {getLabelTagsArray(sportsGoalsOptions, goals?.sports_details)}
          {hasDynamicOthersContent(goals?.sports_others)
            ? getLabelTagsWithDynamicInputs(goals?.sports_others)
            : null}
        </>
      );
    }
    if (goals?.neuro) {
      pushGoalsItems(
        "4",
        "Neuro",
        <>
          {getLabelTagsArray(neuroGoalsOptions, goals?.neuro_details)}
          {hasDynamicOthersContent(goals?.neuro_others)
            ? getLabelTagsWithDynamicInputs(goals?.neuro_others)
            : null}
        </>
      );
    }
    if (hasDynamicOthersContent(goals?.others)) {
      pushGoalsItems(
        "5",
        "Others",
        getLabelTagsWithDynamicInputs(goals?.others)
      );
    }
    return therapeuticGoalsSummaryItems;
  };
  const therapeuticGoalsSummaryItems = constructTherapeuticGoalsSummaryItems();
  return (
    <SummaryWrapper
      items={therapeuticGoalsSummaryItems}
      title={
        <span style={{ fontWeight: "500", marginLeft: ".2rem" }}>
          <Space>
            <Image width="18px" src={therapeuticgoalsIcon} preview={false} />
            <span>Therapeutic Goals</span>
          </Space>
        </span>
      }
    />
  );
};

export default PhysioTherapeuticGoalsSummary;
